<svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5975 0.25H0.402501C0.0667189 0.25 -0.120773 0.604531 0.0871726 0.846567L5.68467 7.33721C5.84489 7.523 6.1534 7.523 6.31533 7.33721L11.9128 0.846567C12.1208 0.604531 11.9333 0.25 11.5975 0.25Z" />
</svg>
